import { useSelector } from 'react-redux'

import { getUserIdentity } from '~/redux-modules/identity'
import { IdentityType } from '~/redux-modules/identity/type'

export default function getFlagValue(identity: IdentityType, flag: string) {
    const { flags } = identity

    return flags?.[flag] || null
}

export function useFlagValue(flag: string, defaultValue = ''): string {
    const identity = useSelector(getUserIdentity)

    return getFlagValue(identity, flag) ?? defaultValue
}
